document.addEventListener("DOMContentLoaded", function () {
  var buttonOpen = document.querySelector("[data-open-notification]");
  var buttonClose = document.querySelector(
    "customer-notifications-container .halo-sidebar-header"
  );
  var containerNotification = document.querySelector(
    "customer-notifications-container"
  );
  var body = document.querySelector("body");

  if (buttonOpen && buttonClose && containerNotification) {
    buttonOpen.addEventListener("click", function () {
      show();
    });

    buttonClose.addEventListener("click", function () {
      hide();
    });

    body.addEventListener("click", function (event) {
      if (body.classList.contains("notifications-sidebar-show")) {
        if (
          !event.target.closest("#halo-notification-sidebar") &&
          !event.target.closest("[data-open-notification]")
        ) {
          hide();
        }
      }
    });
  }

  function show() {
    body.classList.add("notifications-sidebar-show");
  }

  function hide() {
    body.classList.remove("notifications-sidebar-show");
  }
});
